import Modal from "@/components/base/Modal";
import Button from "@/components/base/Button";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Eliminar",
  cancelLabel = "Cancelar",
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onCancel} title={title}>
      <div className="p-5">
        <div className="flex items-start gap-3">
          <span className="w-10 h-10 rounded-full bg-red-100 text-red-500 flex items-center justify-center shrink-0">
            <i className="ri-delete-bin-line text-lg" />
          </span>
          <p className="text-sm text-foreground-700 leading-relaxed">{message}</p>
        </div>
        <div className="flex gap-3 justify-end mt-6">
          <Button variant="outline" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}